import {
  CERTIFICATE_OF_TITLE_TYPE_OPTIONS,
  FANNIE_MAE_CLASS_OPTIONS,
  YES_NO_OPTIONS,
} from './constants';

type ManufacturedHomeFieldsOptions = {
  watch: (field: string) => unknown;
  handleChange: (field: string, value: unknown) => void;
  showFannieMaeClass: boolean;
};

const MANUFACTURED_TEXT_FIELDS = [
  { name: 'serialNumber', label: 'Property Serial Number' },
  { name: 'model', label: 'Property Model' },
  { name: 'hudLabelNumber', label: 'HUD Label #' },
  { name: 'make', label: 'Property Make / Manufacturer' },
] as const;

export const getManufacturedHomeFields = ({
  watch,
  handleChange,
  showFannieMaeClass,
}: ManufacturedHomeFieldsOptions) => [
  {
    type: 'number',
    name: 'lengthInFeet',
    label: 'Length in Feet',
    dataTestId: 'lengthInFeet',
    placeholder: 'Length in Feet',
    value: watch('lengthInFeet'),
    onChangeHandler: (e) => handleChange('lengthInFeet', e.target.value),
    span: 1,
  },
  {
    type: 'number',
    name: 'widthInFeet',
    label: 'Width in Feet',
    dataTestId: 'widthInFeet',
    placeholder: 'Width in Feet',
    value: watch('widthInFeet'),
    onChangeHandler: (e) => handleChange('widthInFeet', e.target.value),
    span: 1,
  },
  ...MANUFACTURED_TEXT_FIELDS.map(({ name, label }) => ({
    type: 'text' as const,
    name,
    label,
    dataTestId: name,
    placeholder: label,
    span: 2,
  })),
  {
    type: 'select',
    name: 'certOfTitleType',
    label: 'Certificate of Title Type',
    dataTestId: 'certOfTitleType',
    options: CERTIFICATE_OF_TITLE_TYPE_OPTIONS,
    onChangeHandler: (value: string) => handleChange('certOfTitleType', value),
    span: 2,
  },
  {
    type: 'select',
    name: 'fannieMaeClass',
    label: 'Fannie Mae Class',
    dataTestId: 'fannieMaeClass',
    options: FANNIE_MAE_CLASS_OPTIONS,
    onChangeHandler: (value: unknown) => handleChange('fannieMaeClass', value),
    span: 2,
    isHidden: () => !showFannieMaeClass,
  },
  {
    type: 'radioGroup',
    name: 'newOrUsedIndicator',
    label: 'Property Type',
    dataTestId: 'newOrUsedIndicator',
    options: [
      { value: '1', label: 'New' },
      { value: '0', label: 'Used' },
    ],
    value: 'newOrUsedIndicator',
    onChangeHandler: (value: string) =>
      handleChange('newOrUsedIndicator', Number(value)),
    span: 1,
    marginTop: '0.2rem',
  },
  {
    type: 'radioGroup',
    name: 'mobileHomeParkFlag',
    label: 'Mobile Home Park',
    dataTestId: 'mobileHomeParkFlag',
    options: YES_NO_OPTIONS,
    value: 'mobileHomeParkFlag',
    onChangeHandler: (value: string) =>
      handleChange('mobileHomeParkFlag', Number(value)),
    span: 1,
    marginTop: '0.2rem',
  },
  {
    type: 'radioGroup',
    name: 'attachToFoundationFlag',
    label: 'Attached To Foundation',
    dataTestId: 'attachToFoundationFlag',
    options: YES_NO_OPTIONS,
    value: 'attachToFoundationFlag',
    onChangeHandler: (value: string) =>
      handleChange('attachToFoundationFlag', Number(value)),
    span: 1,
    marginTop: '0.2rem',
  },
];
